import { EmblaInstance } from 'hooks/useEmblaCarousel'

import { getData } from 'helpers/dom'

class CarouselEmbla extends HTMLElement {
  constructor() {
    super()

    this.options = this.getAttribute('data-options') ? JSON.parse(getData('options', this)) : null
    this.plugins = {
      autoplay: this.hasAttribute('data-autoplay') && this.getAttribute('data-autoplay')
    }
    this.instance = new EmblaInstance(this, this.options, this.plugins)
  }
}

customElements.define('carousel-embla', CarouselEmbla)
